export default {
	"receiptcreate": {
		"btnReceipt": "proof of delivery",
		"electronicReceipt": "Electronic proof of delivery",
		"electronicReceiptStatus": "status of electronic proof of delivery",
		"electronicReceiptPersonName": "ePOD uploader",
		"electronicReceiptDt": "Electronic receipt time",
		"electronicReceiptCheckedDt": "ePOD confirmation time",
		"checkedPersonName": "ePOD examiner",
		"paperyReceipt": "paper POD",
		"backCheckedStatus": "status of paper POD",
		"backPersonName": "POD uploader",
		"backCheckedPersonName": "POD confirmer",
		"backCheckedPersonDt": "POD confirmation time",
		"backConfirmDt": "time of POD received",
		"mailBackDt": "Time of POD sent",
		"expressNo": "tracking number",
		"signPersonDt": "signed time",
		"backTabInfo": "POD information",
		"receiptStatusChecked": "confirmed",
		"checkedReceipt": "Confirm POD",
		"receiptStatusBacked": "Receipt",
		"emailLog": "Receipt email content",
		"paperyReceiptForShipperConfirm": "Shipper's receipt confirmation"
	},
	"receiptemail": {
		"sendEmailTips": "Are you sure to send the email?",
		"receiptWait": "Wait"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/receipt/receipt.js